define('StellarGrade.ST_Common_Shopping.Main', [
    'StellarGrade.ST_Common.PartnerRequestForm.View',
    'StellarGrade.ST_Common.GeneralSalesForm.View',
    'StellarGrade.ST_Common.SupportCaseForm.View',
], function (PartnerRequestFormView, GeneralSalesFormView, SupportCaseFormView) {
    'use strict';

    return {
        mountToApp: function (container) {
            PartnerRequestFormView.loadModule(container);
            GeneralSalesFormView.loadModule(container);
            SupportCaseFormView.loadModule(container);
        },
    };
});
